/* Bella Ballou: nummer-navigation til stablet produktgalleri (snippets/bb-media-index.liquid) */
if (!customElements.get('bb-media-index')) {
  customElements.define(
    'bb-media-index',
    class BbMediaIndex extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onIntersect = this.onIntersect.bind(this);
        this.refresh = this.refresh.bind(this);
        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      }

      connectedCallback() {
        this.gallery = document.getElementById(this.dataset.galleryId);
        if (!this.gallery) return;

        this.buttons = Array.from(this.querySelectorAll('.bb-media-index__button'));
        this.addEventListener('click', this.onClick);
        this.desktopQuery.addEventListener('change', this.refresh);

        // Dawn flytter/indsætter slides ved variantskift – byg mapping og observer igen
        this.mutationObserver = new MutationObserver(this.refresh);
        this.mutationObserver.observe(this.gallery, { childList: true });

        this.refresh();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.desktopQuery.removeEventListener('change', this.refresh);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
      }

      refresh() {
        this.slides = Array.from(this.gallery.querySelectorAll(':scope > .product__media-item'));
        this.buttons.forEach((button, index) => {
          button.closest('li').hidden = index >= this.slides.length;
        });
        this.hidden = this.slides.length < 2;

        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (!this.desktopQuery.matches || this.hidden) return;

        // Et billede er "aktivt", når det krydser midten af viewporten
        this.intersectionObserver = new IntersectionObserver(this.onIntersect, {
          rootMargin: '-50% 0px -50% 0px',
          threshold: 0,
        });
        this.slides.forEach((slide) => this.intersectionObserver.observe(slide));
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
        });
      }

      onClick(event) {
        const button = event.target.closest('.bb-media-index__button');
        if (!button) return;

        const slide = this.slides[Number(button.dataset.index)];
        if (!slide) return;

        const top = slide.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top, behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth' });
        this.setActive(Number(button.dataset.index));
      }

      setActive(index) {
        if (index < 0) return;
        this.buttons.forEach((button, i) => {
          if (i === index) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
